import * as angular from "angular";

export class AppTypeDataProvider {
    private readonly isLeaderView: boolean;

    private localStorage: any;
    private app_type: string | null = null;
    private leader_app_type: string | null = null;

    constructor(localStorageService: any, __app_type: string) {
        this.isLeaderView = __app_type == "LEADER";
        this.localStorage = localStorageService;
    }

    getAppType(): string {
        let appType = this.isLeaderView ? this.leader_app_type : this.app_type;
        if (appType) return appType;

        if (this.localStorage.isSupported) {
            if (this.isLeaderView) {
                appType = this.leader_app_type =
                    this.localStorage.get("leader_app_type");
            } else {
                appType = this.app_type = this.localStorage.get("app_type");
            }
        }

        return appType || "all";
    }

    setAppType(newAppType: string): void {
        if (this.isLeaderView) {
            this.leader_app_type = newAppType;
        } else {
            this.app_type = newAppType;
        }

        if (this.localStorage.isSupported) {
            const key = this.isLeaderView ? "leader_app_type" : "app_type";
            this.localStorage.set(key, newAppType);
        }
    }
}

angular
    .module("vcDataProvider")
    .service("AppTypeDataProvider", AppTypeDataProvider);
